<div class="pdf-container">
  @if (isBrowser()) {
    <ng-container #container></ng-container>
<!-- outputs: { loadComplete: onLoadComplete.bind(this), pageChange: onPageChange.bind(this) }" -->
    <div class="pdf-toolbar" *ngIf="totalPages > 0">
      <div class="navigation-controls">
        <button mat-icon-button (click)="prevPage()" [disabled]="currentPage === 1">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
        <button mat-icon-button (click)="nextPage()" [disabled]="currentPage === totalPages">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  } @else {
    <div style="min-height: 65vh; display: flex; align-items: center; justify-content: center;">
      <app-loader></app-loader>
    </div>
  }
</div>

<!-- @if (isBrowser()) {
  @defer (on timer(0s)) {
    <pdf-viewer 
      [src]="pdfSrc"
      [(page)]="currentPage"
      [render-text]="true"
      [original-size]="false"
      [show-all]="false" 
      [fit-to-page]="true"
      (after-load-complete)="onLoadComplete($event)"
      (pageChange)="onPageChange($event)"
      style="width: 100%; min-height: 65vh; display: block;">
    </pdf-viewer>
    <div class="pdf-toolbar" *ngIf="totalPages > 0">
      <div class="navigation-controls">
        <button mat-icon-button (click)="prevPage()" [disabled]="currentPage === 1">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <span class="page-info">
          Page {{ currentPage }} of {{ totalPages }}
        </span>

        <button mat-icon-button (click)="nextPage()" [disabled]="currentPage === totalPages">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  }
} @else {
  <div style="min-height: 65vh; display: flex; align-items: center; justify-content: center;">
    <app-loader></app-loader>
  </div>
}

 <pdf-viewer 
    [src]="pdfSrc"
    [(page)]="currentPage"
    [render-text]="true"
    [original-size]="false"
    [show-all]="false" 
    [fit-to-page]="true"
    (after-load-complete)="onLoadComplete($event)"
    (pageChange)="onPageChange($event)"
    style="width: 100%; min-height: 65vh; display: block;">
  </pdf-viewer>
  <div class="pdf-toolbar" *ngIf="totalPages > 0">
    <div class="navigation-controls">
      <button mat-icon-button (click)="prevPage()" [disabled]="currentPage === 1">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      
      <span class="page-info">
        Page {{ currentPage }} of {{ totalPages }}
      </span>

      <button mat-icon-button (click)="nextPage()" [disabled]="currentPage === totalPages">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
} -->